import type { ResolverMap } from './ResolverMap'
import type { DashboardTaskCode } from '~/services/api/generated'

type CompleteStoreSetupReason = 'ready' | 'incomplete'
type DashboardTaskLockReason = 'locked'

const dashboardTaskDescriptionByCode = {
  CREATE_STORE: 'presentation.dashboardTask.createStoreDescription',
  CREATE_FIRST_MENU: 'presentation.dashboardTask.createFirstMenuDescription',
  SETUP_PARTNER_PAYOUT_ACCOUNT: 'presentation.dashboardTask.setupPartnerPayoutAccountDescription',
  VERIFY_EMAIL: 'presentation.dashboardTask.verifyEmailDescription',
  COMPLETE_STORE_SETUP: 'presentation.dashboardTask.completeStoreSetupDescriptionIncomplete',
  UPLOAD_LOGO_COVER: 'presentation.dashboardTask.uploadLogoCoverDescription',
  INVITE_TEAM_MEMBERS: 'presentation.dashboardTask.inviteTeamMembersDescription',
  ADD_ANOTHER_STORE: 'presentation.dashboardTask.addAnotherStoreDescription',
  SET_UP_BRAND: 'presentation.dashboardTask.setUpBrandDescription',
  ACCEPT_MSA: 'presentation.dashboardTask.acceptMsaDescription',
  ENABLE_MFA: 'presentation.dashboardTask.enableMfaDescription'
} satisfies Record<DashboardTaskCode, string>

// A task locked behind brand setup explains what unlocks it instead of what it does.
const lockedByBrandSetup = {
  locked: 'presentation.dashboardTask.lockedByBrandSetupDescription'
} satisfies Record<DashboardTaskLockReason, string>

const dashboardTaskDescriptionByReason: Partial<Record<DashboardTaskCode, Record<string, string>>> =
  {
    ACCEPT_MSA: {
      locked: 'presentation.dashboardTask.acceptMsaLockedDescription'
    } satisfies Record<DashboardTaskLockReason, string>,
    COMPLETE_STORE_SETUP: {
      ready: 'presentation.dashboardTask.completeStoreSetupDescriptionReady',
      incomplete: 'presentation.dashboardTask.completeStoreSetupDescriptionIncomplete'
    } satisfies Record<CompleteStoreSetupReason, string>,
    CREATE_FIRST_MENU: lockedByBrandSetup,
    CREATE_STORE: lockedByBrandSetup,
    SETUP_PARTNER_PAYOUT_ACCOUNT: lockedByBrandSetup
  }

export const dashboardTaskDescriptionResolverMap: ResolverMap<DashboardTaskCode> = {
  byCode: dashboardTaskDescriptionByCode,
  byReason: dashboardTaskDescriptionByReason,
  genericKey: 'presentation.dashboardTask.genericDescription'
}
